import api from './api';

export const listBillingDocuments = async (params = {}) => {
  const { data } = await api.get('/billing', { params });
  return data;
};

export default { listBillingDocuments };
